import { inject } from "mobx-react";
import { Fragment, useMemo } from "react";
import { makeAd } from "@inferno/renderer-shared-core";
import { AdPosition } from "../../../../core/page-blocks/Ad.component";
import { Heading } from "../../../../core/ui";
import { CoastFeedItemType, CoastFeedShowsProps, getFeedSubtitle } from "../../lib/coastFeed";
import { CoastFeedNavigation } from "./coast-feed-navigation/CoastFeedNavigation.component";
import { CoastFeedAds } from "./CoastFeedAds.component";
import { CoastFeedNoResults } from "./CoastFeedNoResults.component";
import { CoastFeedShowItem } from "./CoastFeedShowItem.component";

export const CoastFeedShows = inject("store")(({ block, store, content, type, title }: CoastFeedShowsProps) => {
  if (!store) {
    return null;
  }

  const subtitle = useMemo(() => getFeedSubtitle(store.routeParams), [store.routeParams]);

  const firstItemAd = makeAd("3308", 0);

  const itemCount = content?.length || 0;
  const blockSize = block.value.size;

  // only display the header block if there are no feed filters selected
  const displayFirstItemBlock = !Object.keys(store.routeParams).length;

  /**
   * since we're using the first item on the feed in the header
   * we need to offset the length of the next pages (load more)
   * we do end up not showing the last item from each load more till next load more is invoked
   * but this is fine
   */
  const feedCardsContent = displayFirstItemBlock
    ? content?.slice(1, itemCount - Math.ceil(itemCount / blockSize) + 1)
    : content;

  return (
    <Fragment>
      <Heading level={2}>{title}</Heading>
      {type === CoastFeedItemType.SHOW ? <Heading level={3}>{subtitle}</Heading> : null}

      {displayFirstItemBlock && content?.length ? (
        <section className="coast-feed-header">
          <CoastFeedShowItem item={content[0]} type={type} />
          <AdPosition block={firstItemAd} batchId="first-item" />
        </section>
      ) : null}

      {type === CoastFeedItemType.SHOW ? <CoastFeedNavigation /> : null}

      {feedCardsContent?.length ? (
        <div className="feed-cards">
          {feedCardsContent.map((item, itemIdx) => (
            <Fragment key={item.id}>
              <CoastFeedShowItem item={item} type={type} />
              <CoastFeedAds
                blockSize={displayFirstItemBlock ? blockSize - 1 : blockSize}
                itemCount={feedCardsContent.length}
                blockId={block.id}
                itemIdx={itemIdx}
              />
            </Fragment>
          ))}
        </div>
      ) : (
        <CoastFeedNoResults />
      )}
    </Fragment>
  );
});

export default CoastFeedShows;
